import { PlusOutlined } from '@ant-design/icons';
import { Button, Dropdown, Flex, MenuProps } from 'antd';
import React, { useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';

import useDispatchSetterStore from '../hooks/useDispatchSetterStore';
import useDynamicSelector from '../hooks/useDynamicSelector';
import { SmxPropsTableContext } from '../providers/propsTableProvider';
import { getSetterTable, ITableState } from '../store/slices/tableSlice';
import { FilterTableParamType, StoreGroupFilterType, TableColumnOptionsType, TableColumnSmxType } from '../types';
import { getItemsListForFilter } from './functions';
import useProcessedColumns from './hooks/useProcessedColumns';
import TableGroupFilterArr from './tableGroupFilterArr';

interface ITableGroupFilter {
    paramFilter?: FilterTableParamType;
}

const TableGroupFilter: React.FC<ITableGroupFilter> = ({ paramFilter }) => {
    const { nameQuery, prefixStore } = useContext(SmxPropsTableContext);
    const columns: TableColumnSmxType[] = useDynamicSelector('table', 'columns');
    const setterTable = useDispatchSetterStore<ITableState>(getSetterTable(nameQuery + prefixStore));
    const listGroupFilters = useDynamicSelector('table', 'listGroupFilters');
    const options = useProcessedColumns<TableColumnOptionsType>(columns, 'options');

    const columnsKeyAsFilter = columns.filter((column) => paramFilter?.[column.key]).map((column) => column.key);

    const handleMenuClick = (option: TableColumnOptionsType) => () => {
        const newKeyGroup = uuidv4();
        const newKeyFilter = uuidv4();

        setterTable({
            listGroupFilters: {
                ...(listGroupFilters || {}),
                [newKeyGroup]: {
                    key: newKeyGroup,
                    condition: 'and',
                    listFilters: {
                        [newKeyFilter]: {
                            key: newKeyFilter,
                            parentKey: newKeyGroup,
                            condition: 'none',
                            value: '',
                            option,
                        },
                    },
                },
            } as StoreGroupFilterType,
        });
    };

    const items: MenuProps['items'] = getItemsListForFilter(options, columnsKeyAsFilter, handleMenuClick);

    const arrayGroupFilters = Object.values(listGroupFilters);

    let isDisabled = false;
    if (arrayGroupFilters.length) {
        const lastFilterGroup = arrayGroupFilters[arrayGroupFilters.length - 1];
        const listFilters = Object.values(lastFilterGroup.listFilters);
        const lastFilter = listFilters[listFilters.length - 1];
        isDisabled = Boolean(lastFilter.condition === 'none' || lastFilter.value === '');
    }

    return (
        <Flex vertical={Boolean(arrayGroupFilters.length)} align={arrayGroupFilters.length ? 'flex-start' : 'center'}>
            {arrayGroupFilters.map((group) => (
                <TableGroupFilterArr key={group.key} group={group} paramFilter={paramFilter} />
            ))}
            {!arrayGroupFilters.length && (
                <Dropdown menu={{ items }} placement="bottomLeft" arrow={{ pointAtCenter: true }} trigger={['click']}>
                    <Button type="link" disabled={isDisabled}>
                        <PlusOutlined />
                        Add filter
                    </Button>
                </Dropdown>
            )}
        </Flex>
    );
};

export default TableGroupFilter;
